import React, { useEffect, useState } from "react";
import parse from 'html-react-parser';
import { Formik, Field, Form } from 'formik';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { Button } from "semantic-ui-react";
import { QuestionnaireQuestionsAndChoicesAndAnswers } from '../models/QuestionnaireQuestionsAndChoicesAndAnswers';
import { ChoiceAndAnswer } from "../models/ChoiceAndAnswer";
import '../css/custom.css';
import logo from '../img/em_logo.svg'
import { getEnv } from "../api/env";
import { parseQueryParameters } from "../api/idcApi";
import { oauth2 } from "../api/oauth";
import Error from "./Error";
import Loading from "./Loading";

const TITLE = 'Diversity, Equity and Inclusion Survey';

export function CollectData() {
    const [cookies, setCookie, removeCookie] = useCookies(['EMSessionID']);
    const [state, setState] = useState({ loading: true, error: '' });
    const [questionnaireQuestionsAndChoicesAndAnswers, setQuestionnaire] = useState<QuestionnaireQuestionsAndChoicesAndAnswers | null>(null);
    let [choicesAndAnswers, setChoicesAndAnswers] = useState<ChoiceAndAnswer[]>([]);
    if (questionnaireQuestionsAndChoicesAndAnswers != null &&
        questionnaireQuestionsAndChoicesAndAnswers.questionIndex < questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers.length) {
        choicesAndAnswers = questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers[questionnaireQuestionsAndChoicesAndAnswers.questionIndex].choicesAndAnswers;
    }

    document.title = TITLE;
    var EMSessionID:string = cookies.EMSessionID == null ? "" : cookies.EMSessionID;

    useEffect(() => {
        if (state.error === '') {
            if (questionnaireQuestionsAndChoicesAndAnswers === null) {
                oauth2(EMSessionID)
                    .then((token) => {
                        getQuestionnaire(token);
                    })
                    .catch((e) => {
                        let msg = "Failure during oauth flow.\r\n" + e;
                        setState({ loading: false, error: msg });
                    })
            }
        }
    }, [])

    // Check querystring
    if (state.error === '' && sessionStorage.getItem("journal") === null && questionnaireQuestionsAndChoicesAndAnswers === null) {
        if (window.location.search !== "") {
            parseQueryParameters();
        }
        if (window.location.search === "" ||
            sessionStorage.getItem("journal") === null || sessionStorage.getItem("languageCode") === null || sessionStorage.getItem("peopleIdentifier") === null || sessionStorage.getItem("role") === null || sessionStorage.getItem("questionnaireId") === null) {
            let msg = "Querystring parameters are not correct.";
            setState({ loading: false, error: msg });
        }
        else if (state.loading) {
            console.log("Loading...")
            return (<Loading />);
        }
    }

    if (state.error !== '') {
        console.error(state.error);
        return (<Error />);
    }
    if (state.loading) {
        console.log("Loading...");
        return (<Loading />);
    }

    async function getQuestionnaire (token: string)  {

        if (state.error === '') {
            var queryString = sessionStorage.getItem("queryString") + "&token=" + token;
            let idcApi = await getEnv("REACT_APP_IDC_API_BASE_URL");

            await axios.get(idcApi + 'collectdata' + queryString)
                .then(response => {
                    setQuestionnaire(response.data);
                    setState({ loading: false, error: '' });
                }).catch((e) => {
                    let msg = "Failure getting questionnaire.\r\n" + e.message + "\r\n" + e.response.data;
                    setState({ loading: false, error: msg });
                })
        }
    }

    async function saveQuestionnaire() {

        if (state.error === '') {
            let idcApi = await getEnv("REACT_APP_IDC_API_BASE_URL");
            await axios.post(idcApi + 'SaveData', questionnaireQuestionsAndChoicesAndAnswers)
                .then(response => {
                    setChoicesAndAnswers([]);
                    setState({ loading: false, error: '' });
                }).catch((e) => {
                    if (e.response !== undefined && e.response.data.errorMessage !== undefined &&
                        e.response.data.errorMessage.includes("tags are not allowed in Self describe") &&
                        questionnaireQuestionsAndChoicesAndAnswers !== null) {
                        e.response.data.questionIndex--;
                        setQuestionnaire(e.response.data);
                        setState({ loading: false, error: '' });
                        alert(e.response.data.errorMessage);
                        return;
                    }
                    let msg = "Failure saving answers.\r\n" + e.message;
                    if (e.response !== undefined) {
                        msg = msg + "\r\n" + e.response.data;
                    }
                    setState({ loading: false, error: msg });
                })
        }
    }

    function renderQuestionnaire(questionnaireQuestionsAndChoicesAndAnswers: QuestionnaireQuestionsAndChoicesAndAnswers | null):JSX.Element {
        let question:JSX.Element = <div></div>;
        let confirmation = <div></div>;
        let choices = <div></div>;
        let buttons = <div></div>;
        if (questionnaireQuestionsAndChoicesAndAnswers === null) {
            return <div></div>;
        }

        if (questionnaireQuestionsAndChoicesAndAnswers.questionIndex < questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers.length) {
            question = renderQuestion(questionnaireQuestionsAndChoicesAndAnswers);

            if (questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers[questionnaireQuestionsAndChoicesAndAnswers.questionIndex].question.multipleSelections) {
                choices = renderCheckButtons(choicesAndAnswers);
            }
            else {
                choices = renderRadioButtons(choicesAndAnswers);
            }
            buttons = renderButtons(choicesAndAnswers, questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers[questionnaireQuestionsAndChoicesAndAnswers.questionIndex].question.buttonText);
        }
        else {
            confirmation = renderConfirmation(questionnaireQuestionsAndChoicesAndAnswers);
            buttons = renderButtons(null, questionnaireQuestionsAndChoicesAndAnswers.questionnaire.confirmationButtonText)
        }

        return (
            <Formik initialValues={questionnaireQuestionsAndChoicesAndAnswers} onSubmit={values => console.log(values.questionAndChoicesAndAnswers)}>
                {({ values: questionnaireQuestionsAndChoicesAndAnswers, handleChange, handleSubmit }) => (
                    <Form className="diversityText">
                        <div className="content">
                            <table className="table" aria-labelledby="tableLabel"><tbody>
                                <tr>
                                    <td className="logo-cell"><img src={logo} className='logo' alt="" /></td>
                                    <h1 className='header-text'>{parse(questionnaireQuestionsAndChoicesAndAnswers.questionnaire.headerText)}</h1>
                                </tr>
                            </tbody></table>
                            {questionnaireQuestionsAndChoicesAndAnswers.questionIndex < questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers.length
                                && question}
                            {questionnaireQuestionsAndChoicesAndAnswers.questionIndex < questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers.length
                                && choices}
                            {questionnaireQuestionsAndChoicesAndAnswers.questionIndex >= questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers.length
                                && confirmation}
                        </div>
                        <div className="footer">
                            {buttons}
                        </div>
                    </Form>
                )}
            </Formik>
        );

    }
    function renderQuestion(questionnaireQuestionsAndChoicesAndAnswers: QuestionnaireQuestionsAndChoicesAndAnswers):JSX.Element {
        return (
            <div key={questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers[questionnaireQuestionsAndChoicesAndAnswers.questionIndex].question.questionId}>
                <div className='question-instructions-title'>
                    {parse(questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers[questionnaireQuestionsAndChoicesAndAnswers.questionIndex].question.questionInstructionTitle)}
                </div>
                <div className='question-instructions'>
                    {parse(questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers[questionnaireQuestionsAndChoicesAndAnswers.questionIndex].question.questionInstructions)}
                </div>
                <div>
                    {parse(questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers[questionnaireQuestionsAndChoicesAndAnswers.questionIndex].question.questionText)}
                </div>
                <div>
                    {parse(questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers[questionnaireQuestionsAndChoicesAndAnswers.questionIndex].question.chooseText)}
                </div>
            </div>
        );
    }

    function renderRadioButtons(choicesAndAnswers: ChoiceAndAnswer[]): JSX.Element {
        return (
            <div>
                <table><tbody>
                    {choicesAndAnswers.map((choiceAndAnswer: ChoiceAndAnswer) => (
                        <tr key={choiceAndAnswer.choice.questionChoiceId}>
                            <td scope="col">
                                <label>
                                    <Field type="radio" className="choicebox" name="questionType" value={choiceAndAnswer.choice.questionChoiceTypeId}
                                        onChange={() => handleRadioChange(choiceAndAnswer)}
                                        checked={choiceAndAnswer.selected} />
                                    {parse(choiceAndAnswer.choice.choice)}
                                </label>
                            </td>
                        </tr>
                    ))}
                </tbody></table>
            </div>
        );

    }

    function renderCheckButtons(choicesAndAnswers: ChoiceAndAnswer[]): JSX.Element {
        return (
            <div>
                <table><tbody>
                    {choicesAndAnswers.map((choiceAndAnswer: ChoiceAndAnswer) => (
                        <tr key={choiceAndAnswer.choice.questionChoiceId}><td colSpan={2}>
                            <label>
                                <Field type="checkbox" className="choicebox" name="questionType" value={choiceAndAnswer.choice.questionChoiceTypeId}
                                    onChange={() => handleCheckChange(choiceAndAnswer)}
                                    checked={choiceAndAnswer.selected ? 'checked' : ''} />
                                {parse(choiceAndAnswer.choice.choice)}
                            </label>&nbsp;&nbsp;&nbsp;
                            {choiceAndAnswer.choice.displayTextbox &&
                                <input type='text' id='selfDescribe' onChange={() => handleChange(choiceAndAnswer)} disabled={!choiceAndAnswer.selected}
                                    value={choiceAndAnswer.answer.selfDescribe ?? ''} aria-label="Enter self describe." />}
                        </td></tr>
                    ))}
                </tbody></table>
            </div>
        );
    }

    function renderConfirmation(questionnaireQuestionsAndChoicesAndAnswers: QuestionnaireQuestionsAndChoicesAndAnswers): JSX.Element {
        return (
            <div>
                <div className="confirmation-text">{parse(questionnaireQuestionsAndChoicesAndAnswers.questionnaire.confirmationText)}</div>
            </div>
        );
    }

    function renderButtons(choicesAndAnswers: ChoiceAndAnswer[] | null, buttonText: string): JSX.Element {
        let buttonEnabled = false;
        let cancelButtonVisible = questionnaireQuestionsAndChoicesAndAnswers!.questionIndex === 0;
        let backButtonVisible = questionnaireQuestionsAndChoicesAndAnswers!.questionIndex > 0 &&
            questionnaireQuestionsAndChoicesAndAnswers!.questionIndex < questionnaireQuestionsAndChoicesAndAnswers!.questionAndChoicesAndAnswers.length;
        if (choicesAndAnswers != null) {
            if (questionnaireQuestionsAndChoicesAndAnswers!.questionIndex < questionnaireQuestionsAndChoicesAndAnswers!.questionAndChoicesAndAnswers.length) {
                for (let i = 0; i < choicesAndAnswers.length; i++) {
                    if (choicesAndAnswers[i].selected && choicesAndAnswers[i].choice.questionChoiceTypeId === 11 &&
                        (choicesAndAnswers[i].answer.selfDescribe === null || choicesAndAnswers[i].answer.selfDescribe === '')) {
                        buttonEnabled = false;
                        break;
                    }
                    else if (choicesAndAnswers[i].selected) {
                        buttonEnabled = true;
                    }
                }
            }
        }
        else {
            buttonEnabled = true;
        }

        return (
            <div>
                <hr className="line-1"></hr>
                <div className="buttonAlign">
                    {cancelButtonVisible ? <a className="cancelLink" href="" onClick={() => window.close()}>Cancel</a> : null}
                    {backButtonVisible ? <Button type="button" className="white-back-button" onClick={() => handleGoBack()} >Back</Button> : null}
                    <Button type="submit" className="blue-submit-button" onClick={() => handleSubmit()} disabled={!buttonEnabled} >{buttonText}</Button>
                </div>
            </div>
        );
    }

    function handleGoBack(): void {
        if (questionnaireQuestionsAndChoicesAndAnswers != null) {
            questionnaireQuestionsAndChoicesAndAnswers.questionIndex--;
            setQuestionnaire(questionnaireQuestionsAndChoicesAndAnswers);
            if (questionnaireQuestionsAndChoicesAndAnswers.questionIndex < questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers.length) {
                setChoicesAndAnswers(questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers[questionnaireQuestionsAndChoicesAndAnswers.questionIndex].choicesAndAnswers);
            }
        }
    }

    function handleSubmit(): void {
        if (questionnaireQuestionsAndChoicesAndAnswers != null) {
            if (questionnaireQuestionsAndChoicesAndAnswers.questionIndex < questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers.length) {
                var input = document.getElementById('selfDescribe') != null ? document.getElementById('selfDescribe') as HTMLInputElement : null;
                if (input != null && input.value !== "") {
                    var inputValue = input.value;
                    var invalidTag = unauthorizedHTMLCheck(inputValue);
                    if (invalidTag) {
                        alert(invalidTag + " tags are not allowed in Self describe.");
                        let caa = [...choicesAndAnswers];
                        for (let i = 0; i < caa.length; i++) {
                            if (caa[i].choice.questionChoiceTypeId === 11) {
                                caa[i].answer.selfDescribe = "";
                                break;
                            }
                        }
                        setChoicesAndAnswers(caa);
                        return;
                    }
                }
            }
            questionnaireQuestionsAndChoicesAndAnswers.questionIndex++;
            setQuestionnaire(questionnaireQuestionsAndChoicesAndAnswers);
            if (questionnaireQuestionsAndChoicesAndAnswers.questionIndex < questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers.length) {
                setChoicesAndAnswers(questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers[questionnaireQuestionsAndChoicesAndAnswers.questionIndex].choicesAndAnswers);
            }
            else if (questionnaireQuestionsAndChoicesAndAnswers.questionIndex === questionnaireQuestionsAndChoicesAndAnswers.questionAndChoicesAndAnswers.length) {
                saveQuestionnaire();
                setState({ loading: true, error: '' });
            }
            else {
                window.close();
            }
        }
    }

    function handleRadioChange(obj: ChoiceAndAnswer): void {
        let caa = [...choicesAndAnswers];
        for (let i = 0; i < caa.length; i++) {
            caa[i].selected = false;
        }
        let idx = choicesAndAnswers.indexOf(obj);
        caa[idx].selected = true;
        setChoicesAndAnswers(caa);
    }

    function handleCheckChange(obj: ChoiceAndAnswer): void {
        let newValue = !obj.selected;
        let idx = choicesAndAnswers.indexOf(obj);
        let caa = [...choicesAndAnswers];

        if (caa[idx].choice.questionChoiceTypeId === 4)  // Prefer Not to Disclose
        {
            for (let i = 0; i < caa.length; i++) {
                caa[i].selected = false;
            }
        }

        else {
            for (let i = 0; i < caa.length; i++) {
                if (caa[i].choice.questionChoiceTypeId === 4) {
                    caa[i].selected = false;
                    break;
                }
            }
        }

        caa[idx].selected = newValue;
        setChoicesAndAnswers(caa);
    }

    function handleChange(obj: ChoiceAndAnswer): void {
        var input = document.getElementById('selfDescribe') as HTMLInputElement;
        var inputValue = input.value;
        let idx = choicesAndAnswers.indexOf(obj);
        let caa = [...choicesAndAnswers];

        caa[idx].answer.selfDescribe = inputValue;
        setChoicesAndAnswers(caa);
    }

    function unauthorizedHTMLCheck(str: string) {
        var scriptRegExp = new RegExp("<(/)*script.*>", "ig");
        if (str.match(scriptRegExp) != null)
            return ("SCRIPT");

        var objectRegExp = new RegExp("<(/)*object.*>", "ig");
        if (str.match(objectRegExp) != null)
            return ("OBJECT");

        // The embed tag was introduced by Netscape and later supported by IE but has never
        // officially been part of HTML.
        var embedRegExp = new RegExp("<(/)*embed.*>", "ig");
        if (str.match(embedRegExp) != null)
            return ("EMBED");

        // The applet tag was deprecated in HTML 4.0 but may still be supported by web browsers.
        var appletRegExp = new RegExp("<(/)*applet.*>", "ig");
        if (str.match(appletRegExp) != null)
            return ("APPLET");

        return ("");
    }

    return (
        <div>
            {renderQuestionnaire(questionnaireQuestionsAndChoicesAndAnswers)}
        </div>
    );
}